import battleReducer from './battle';
import gameReducer from './game';
import panoramaReducer from './pano';
import resultReducer from './result';
import settingsReducer from './settings';

export const reducers = {
    game: gameReducer,
    result: resultReducer,
    battle: battleReducer,
    pano: panoramaReducer,
    settings: settingsReducer,
};
